import { NgModule } from '@angular/core';
import { ApolloModule, APOLLO_OPTIONS } from 'apollo-angular';
import { ApolloClientOptions, InMemoryCache, ApolloLink } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { HttpLink } from 'apollo-angular/http';
import { environment } from '@environments/environment';
import { ClientApplicationHttpHeaders } from '@app/core/api/api-headers';

function onelife(httpLink: HttpLink): ApolloClientOptions<any> {
  return {
    link: ApolloLink.from([
      setContext(() => ({ headers: ClientApplicationHttpHeaders })),
      httpLink.create({
        uri: environment.onelife.graphql.uri,
      }),
    ]),
    cache: new InMemoryCache({
      typePolicies: {
        ChartingTemplate: {
          keyFields: ['type', 'id'],
        },
      },
    }),
  };
}

@NgModule({
  exports: [ApolloModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: onelife,
      deps: [HttpLink],
    },
  ],
})
export class GraphQLModule { }
